// ─────────────────────────────────────────────────────────────────────────────
// navConfig.js — Frontend section grouping for navbar mega dropdown
//
// Maps subcategory names (must match exactly what's in Store Settings DB)
// to their display section within each category's dropdown.
//
// HOW TO UPDATE:
//   1. Add a new subcategory in Admin → Store Settings
//   2. Add it here under the correct category and section name
//   3. If the section name is new, it will automatically create a new column
//
// Any subcategory NOT listed here will appear under "Other" at the end.
// ─────────────────────────────────────────────────────────────────────────────

export const SECTION_MAP = {
    men: {
        // Men's Clothing
        'Shirts':       "Men's Clothing",
        'T-Shirts':     "Men's Clothing",
        'Trousers':     "Men's Clothing",
        'Shorts':       "Men's Clothing",
        'Jeans':        "Men's Clothing",
        'Jackets':      "Men's Clothing",
        'Suits':        "Men's Clothing",
        'Underwear':    "Men's Clothing",
        'Sleepwear':    "Men's Clothing",

        // Men's Accessories
        'Belts':        "Men's Accessories",
        'Ties':         "Men's Accessories",
        'Watches':      "Men's Accessories",
        'Wallets':      "Men's Accessories",
        'Caps':         "Men's Accessories",
        'Sunglasses':   "Men's Accessories",

        // Footwear
        'Shoes':        'Footwear',
        'Sandals':      'Footwear',
        'Slippers':     'Footwear',
        'Boots':        'Footwear',
    },
    women: {
        // Women's Clothing
        'Dresses':      "Women's Clothing",
        'Tops':         "Women's Clothing",
        'Blouse':      "Women's Clothing",
        'Skirts':       "Women's Clothing",
        'Trousers':     "Women's Clothing",
        'Jeans':        "Women's Clothing",
        'Jackets':      "Women's Clothing",
        'Sarees':       "Women's Clothing",
        'Underwear':    "Women's Clothing",
        'Sleepwear':    "Women's Clothing",

        // Women's Accessories
        'Handbags':     "Women's Accessories",
        'Jewellery':    "Women's Accessories",
        'Scarves':      "Women's Accessories",
        'Belts':        "Women's Accessories",
        'Sunglasses':   "Women's Accessories",
        'Watches':      "Women's Accessories",

        // Footwear
        'Heels':        'Footwear',
        'Flats':        'Footwear',
        'Sandals':      'Footwear',
        'Slippers':     'Footwear',
        'Boots':        'Footwear',
    },
    kids: {
        // Boys
        'Boys Shirts':  "Boys",
        'Boys Pants':   "Boys",
        'Boys Shorts':  "Boys",
        'Boys T-Shirts':"Boys",
        'Boys Jackets': "Boys",

        // Girls
        'Girls Dresses':"Girls",
        'Girls Tops':   "Girls",
        'Girls Skirts': "Girls",
        'Girls Jackets':"Girls",

        // Accessories & Footwear
        'School Bags':  'Accessories',
        'Caps':         'Accessories',
        'Shoes':        'Footwear',
        'Sandals':      'Footwear',
        'Slippers':     'Footwear',

        // General
        'Underwear':    'Essentials',
        'Sleepwear':    'Essentials',
        'School Wear':  'Essentials',
    },
    other: {
        // Footwear
        'Shoes':        'Footwear',
        'Sandals':      'Footwear',
        'Slippers':     'Footwear',
        'Boots':        'Footwear',

        // Bags
        'Backpacks':    'Bags',
        'Handbags':     'Bags',
        'Wallets':      'Bags',
        'Travel Bags':  'Bags',

        // Accessories
        'Jewellery':    'Accessories',
        'Sunglasses':   'Accessories',
        'Watches':      'Accessories',
        'Caps':         'Accessories',
        'Belts':        'Accessories',
    }
}

/**
 * Groups an array of subcategory objects by their section
 * using the SECTION_MAP for the given category.
 *
 * @param {Array}  subcategories  — from /subcategories?category=X
 * @param {string} category       — 'men' | 'women' | 'kids' | 'other'
 * @returns {Array} — [{ section: string, items: [{name, path}] }]
 */
export const groupBySection = (subcategories, category) => {
    const map       = SECTION_MAP[category] || {}
    const sections  = {}
    const otherKey  = 'Other'

    subcategories.forEach(sub => {
        const section = map[sub.name] || otherKey
        if (!sections[section]) sections[section] = []
        sections[section].push({
            name: sub.name,
            path: `/shop-products?category=${category}&subCategory=${encodeURIComponent(sub.name)}`
        })
    })

    // Preserve SECTION_MAP order, then append Other at the end
    const orderedSections = []
    const sectionOrder    = [...new Set(Object.values(map))]

    sectionOrder.forEach(sec => {
        if (sections[sec]) {
            orderedSections.push({ section: sec, items: sections[sec] })
        }
    })

    if (sections[otherKey]) {
        orderedSections.push({ section: otherKey, items: sections[otherKey] })
    }

    return orderedSections
}